import React, {useState, useEffect} from 'react';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import axios from 'axios';
import Dropdown from 'react-dropdown';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import Autocomplete, {createFilterOptions } from '@mui/material/Autocomplete'; 
import TextField from '@mui/material/TextField';
import { useAutocomplete } from '@mui/base/AutocompleteUnstyled';
import { styled } from '@mui/system';
import {matchSorter} from 'match-sorter';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Label = styled('label')({
	display: 'block',
});

const Input = styled('input')(({ theme }) => ({
	width: 200,
	backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#000',
	color: theme.palette.mode === 'light' ? '#000' : '#fff',
	paddingLeft: '10px',
}));

const Listbox = styled('ul')(({ theme }) => ({
	width: 200,
	margin: 0,
	padding: '5px',
	zIndex: 1,
	position: 'absolute',
	listStyle: 'none',
	backgroundColor: theme.palette.mode === 'light' ? 'rgba(255,255,255,.95)' : '#000',
	overflow: 'auto',
	maxHeight: 200,
	border: '1px solid rgba(0,0,0,.25)',
	borderRadius: '4px',
	'& li':{
		padding:'0px 5px',
		borderRadius: '4px',
	},
	'& li.Mui-focused': {
	  backgroundColor: 'rgba(35,168,126,.65)',
	  color: 'white',
	  cursor: 'pointer',
	},
	'& li:active': {
	  backgroundColor: '#23a87e',
	  color: 'white',
	},
  }));

export const BuscadorNombres = (props) => {
	const {
		Empresas,
		setEmpresas,
		mapa,
		setMapa,
		setModalUbiacion,
		setEmpresasCargadas,
		getEmpresas_preRegistradas,
		limite,
		setBuscarNombre,
		setBuscarCategoria,
		setBuscarLocalidad,
		setBuscarProvincia,
	} = props;
	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [NombreBuscar, setNombreBuscar] = useState(''.toString());
	const [Categorias, setCategorias] = useState([]);
	const [CategoriaSeleccionada, setCategoriaSeleccionada] = useState({
		nombre: '',
		id: 0,
	});
	const [ListaProvincias, setListaProvincias] = useState([]);
	const [Provincia, setProvincia] = useState({
		nombre: 'Todas',
		id: 0,
	});

	/* Creating a state variable called ListaLocalidades and a function to update it called
    setListaLocalidades. */
	const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [Localidad, setLocalidad] = useState({
		nombre: '',
		id: 0,
	});

	const [localidadSeleccionada, setLocalidadSeleccionada] = useState([])
	const [inputValue, setInputValue] = useState('');

	useEffect(() => {
		definirProvincias();
		setProvincia({
			nombre: 'Todas',
			id: 0,
		});
	}, []);

	useEffect(() => {
		if (Provincia.id !== undefined) {
			axios({
				method: 'get',
				// url: window.ipdirection + 'localidadAll/?id_prov=' + Provincia.id,
				url: window.ipdirection + 'localidadAll'
			}).then((response) => {
				let listaAxu = [];
				/* Mapping the response data and pushing it into an array. */
				listaAxu.push({
					nombre: 'Todas',
					id: 0,
				});
				response.data.forEach((localidad) => {
					listaAxu.push({
						id: localidad.id,
						nombre: localidad.nombre,
						provincia: localidad.provincia,
					});
				});

				setListaLocalidades(listaAxu);
				setLocalidad({
					nombre: 'Todas',
					id: 0,
				});
			});
		}
	}, [Provincia]);

	/**
	 * It gets the data from the backend and sets the state of the listaProvincias variable
	 */
	const definirProvincias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'provinciaAll/',
		}).then((response) => {
			let listaAxu = [];
			listaAxu.push({
				nombre: 'Todas',
				id: 0,
			});
			/* Mapping the response data and pushing it into an array. */
			response.data.forEach((provincia) => {
				listaAxu.push({
					...provincia,
				});
			});
			setListaProvincias(listaAxu);
		});
	};
	const selecionarCategoria = (event) => {
		Categorias.map((categoria) => {
			if (categoria.nombre === event.nombre) {
				setCategoriaSeleccionada(categoria);
			}
		});
	};
	const selecionarProvincia = (event) => {
		document.getElementById('select-hide').removeAttribute('hidden')
		ListaProvincias.map((provincia) => {
			if (provincia.nombre === event.target.value) {
				setProvincia({...provincia});
			}
		});
	};
	const selecionarLocalidad = (event) => {
		ListaLocalidades.forEach((localidad) => {
			if (localidad.nombre === event.nombre) {
				setLocalidad({...localidad});
			}
		});
	};

	const definirCategorias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		})
			.then((response) => {
				let listaAxu = [];
				listaAxu.push({nombre: 'Todas', id: 0});
				response.data.map((categoria) => {
					listaAxu.push({...categoria});
				});
				setCategorias(listaAxu);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const limpiarFiltros = () => {
		/*
        setProvincia({
            nombre: "Todas",
            id: 0
        });
        setNombreBuscar("".toString());
        setCategoriaSeleccionada({
            nombre: "Todas",
            id: 0
        });
        */
	};

	useEffect(() => {
		cargarDatos();
	}, [NombreBuscar, CategoriaSeleccionada, Localidad, Provincia]);

	const cargarDatos = () => {
		setBuscarNombre(CategoriaSeleccionada.nombre);
		setBuscarCategoria(CategoriaSeleccionada.id);
		setBuscarLocalidad(Localidad.id);
		setBuscarProvincia(Provincia.id);
		return {
			nombreEmpresa: NombreBuscar,
			categoria_id: CategoriaSeleccionada,
			localidad_id: Localidad,
			provincia_id: Provincia,
		};
	};
	const searchEmpresas = async () => {
		let data = cargarDatos();
		if (Usuario.tipo === 'usuarioNormal') {
			axios({
				/* Sending a post request to the server. */
				method: 'post',
				url: window.ipdirection + 'logs?logstream=buscarEmpresa',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: {
					usuario: Usuario.cliente.usuario.id,
					query: data.nombreEmpresa.toString(),
					categoria: data.categoria_id.id,
					localidad: data.localidad_id.id,
					provincia: data.provincia_id.id,
					accion: 'buscarEmpresa',
				},
			})
				.then((response) => {})
				.catch((error) => {});
		}
		try {
			console.log('Categoria seleccionada ', CategoriaSeleccionada.nombre);
			// Recupera la lista de empresas.
			const response = await axios({
				method: 'get',
				url:
					window.ipdirection +
					'busquedaAvanzada/?nombreEmpresa=' +
					data.categoria_id.nombre.toString() +
					'&categoria_id=' +
					data.categoria_id.id +
					'&categoria_nombre=' +
					data.categoria_id.nombre.toString()+
					'&localidad_id=' +
					data.localidad_id.id +
					'&provincia_id=' +
					data.provincia_id.id,
			});
			const empresas = response.data;

			getEmpresas_preRegistradas();

			// Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
			const empresasConImagenes = await Promise.all(
				empresas.map(async (empresa) => {
					try {
						const imagenResponse = await axios.get(
							window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`,
							{
								responseType: 'blob',
							}
						);
						const imagenURL = URL.createObjectURL(imagenResponse.data);
						// Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
						return {...empresa, img: imagenURL};
					} catch (error) {
						return {
							...empresa,
							img: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
						};
					}
				})
			);

			// Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
			setEmpresas(empresasConImagenes);
			limpiarFiltros();
		} catch (error) {
			//console.log(error);
		}
	};

	const searchEmpresasMapa = async () => {
		searchEmpresas();
		console.log(mapa);
		setMapa(true);
		console.log(mapa);
		setModalUbiacion(true);
	};

	useEffect(() => {
		definirCategorias();
	}, []);

	const handleLocalidad = (event) => {
		console.log('event ', event);
		const value = event;
		setLocalidadSeleccionada(value);
		const foundLocalidad = ListaLocalidades.find((localidad) => localidad.nombre.toLowerCase() === value.nombre.toLowerCase());
		if (foundLocalidad) {
			selecionarLocalidad(foundLocalidad);
		}
	};

	const filterOptions = createFilterOptions({
		limit:5
	});

	const {
		getRootProps: getRootPropsCategorias,
		getInputLabelProps: getInputLabelPropsCategorias,
		getInputProps: getInputPropsCategorias,
		getListboxProps: getListboxPropsCategorias,
		getOptionProps: getOptionPropsCategorias,
		groupedOptions: groupedOptionsCategorias,
	} = useAutocomplete({
		id: 'autocomplete-categorias',
		options: Categorias,
		getOptionLabel: (option) => option.nombre,
		onInputChange: (event, value) =>{
			setCategoriaSeleccionada({'nombre':value, 'id':0})
		},
		onChange: (event, newValue) => {
			selecionarCategoria(newValue)
		},
	});

	const {
		getRootProps: getRootPropsLocalidades,
		getInputLabelProps: getInputLabelPropsLocalidades,
		getInputProps: getInputPropsLocalidades,
		getListboxProps: getListboxPropsLocalidades,
		getOptionProps: getOptionPropsLocalidades,
		groupedOptions: groupedOptionsLocalidades,
	} = useAutocomplete({
		id: 'autocomplete-localidades',
		options: ListaLocalidades,
		getOptionLabel: (option) => option.nombre,
		inputValue: inputValue,
		onInputChange: (event, value) => {
			console.log('onInputChange - event', event.target.value)
			console.log('onInputChange - value', value)
			setInputValue(value);
		},
		onChange: (event, newValue) => {
			setInputValue(newValue ? newValue.nombre : '');
			handleLocalidad(newValue)
		},
	});

	return (
		<div className='buscadorPorNombre_superior'>
			<div className='buscadorPorNombre'>
				<div className='item-buscadorPorNombre'>
					{/* <div>Texto de búsqueda: </div> */}
					{/* <input
						type='text'
						value={NombreBuscar}
						placeholder='Medicina Roma'
						onChange={(e) => setNombreBuscar(e.target.value)}
					/> */}
					<div>
						<div {...getRootPropsCategorias()}>
							<Input {...getInputPropsCategorias()} placeholder='Empresa o especialidad'
								value={CategoriaSeleccionada.nombre} 
								onChange={(e) => setCategoriaSeleccionada({'nombre':e.target.value, 'id':0})}
							/>
						</div>
						{groupedOptionsCategorias.length > 0 ? (
							<Listbox {...getListboxPropsCategorias()}>
								{groupedOptionsCategorias.map((option, index) => (
									<li {...getOptionPropsCategorias({ option, index })}>{option.nombre}</li>
								))}
							</Listbox>
						) : null}
					</div>
				</div>
				{/*<div className='item-buscadorPorNombre provincia-item-buscadorPorNombre'>
					<div>Provincia: </div>
					<select
						className='dropDown-market-empresa '
						onChange={(event) => selecionarProvincia(event)}
						value={Provincia.nombre}
					>
						{ListaProvincias.map((provincia) => (
							<option value={provincia.nombre}>{provincia.nombre}</option>
						))}
					</select>
				</div>*/}
				<div className='item-buscadorPorNombre localidad-item-buscadorPorNombre'>
					{/* <div>Localidad: </div> */}
					{/* <select
						className='dropDown-market-empresa '
						onChange={(event) => selecionarLocalidad(event)}
						placeholder='Selecionar localidad'
						value={Localidad.nombre}
					>
						{ListaLocalidades.map((localidad) => (
							<option value={localidad.nombre}>{localidad.nombre}</option>
						))}
					</select> */}
					<div>
						<div {...getRootPropsLocalidades()}>
						<Input {...getInputPropsLocalidades()} placeholder='¿Donde?'
								value={inputValue}
								onChange={(e) => {setInputValue(e.target.value)
									console.log('onChange', e.target.value);
								}}
							/>
						</div>
						{groupedOptionsLocalidades.length > 0 ? (
						<Listbox {...getListboxPropsLocalidades()}>
							{groupedOptionsLocalidades.map((option, index) => (
							<li {...getOptionPropsLocalidades({ option, index })}>{option.nombre}</li>
							))}
						</Listbox>
						) : null}
					</div>
				</div>

				{/*<div className='item-buscadorPorNombre'>
					<div>Categoría: </div>
					<select
						className='dropDown-market-empresa '
						onChange={(event) => selecionarCategoria(event)}
						value={CategoriaSeleccionada.nombre}
					>
						{Categorias.map((categoria) => (
							<option value={categoria.nombre}>{categoria.nombre}</option>
						))}
					</select>
				</div>*/}

				<div className='item-buscadorPorNombre centrador_item-buscadorPorNombre'>
					<br />
					<div
						className=' buttonBuscar'
						onClick={() => searchEmpresas()}
					>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='18'
								height='18'
								fill='currentColor'
								class='bi bi-search'
								viewBox='0 0 16 16'
							>
								<path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
							</svg>
						</div>
						<div>
							<b>BUSCAR</b>
						</div>
					</div>
				</div>
				<div className='item-buscadorPorNombre centrador_item-buscadorPorNombre'>
					<br />
					{/* <div
						className=' buttonBuscar'
						onClick={() => searchEmpresasMapa()}
					>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='18'
								height='18'
								fill='currentColor'
								class='bi bi-search'
								viewBox='0 0 16 16'
							>
								<path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
							</svg>
						</div>
						<div>
							<b>BUSCAR EN MAPA</b>
						</div>
					</div> */}
				</div>
			</div>
		</div>
	);
};
